<div class="align-items-center">
	<div class="row full-width full-height">
		<div class="col col-12">
			<div class="row align-items-center" *ngIf="!hasError && !isProcessed" >
				<div class="col col-12 text-center receipt-options">
					<div class="h4">Processing Payment Response</div>
					<div class="full-width align-items-center"><mat-spinner diameter="30"></mat-spinner></div>
				</div>
			</div>
			<div class="row align-items-center" *ngIf="!hasError && isProcessed">
				<div class="col col-12 text-center receipt-options" *ngIf="isProcessed">
					<div>
						<div class="h4">We're sorry, your payment could not be completed.</div>
						<div>{{activeInvoice.paidSource}}</div>
					</div>
					<div style="margin-top: 80px;">
						<div class="h4">How would you like to proceed?</div>
						<div class="row">
							<div class="col col-6 text-center">
								<button mat-raised-button color="default" [routerLink]="['/pay-items', { retryKey: getSearchKey() }]" matTooltip="Click to go back to the order screen and try again.">&nbsp; Try Again &nbsp;</button>
							</div>
							<div class="col col-6 text-center" *ngIf="activeInvoice !== undefined && activeInvoice != null">
								<button mat-raised-button color="default" [routerLink]="['/pay-items', { key: activeInvoice.orderKey, invNum: activeInvoice.invoiceNumber, accepted: activeInvoice.paymentAccepted }]" matTooltip="Click to view transaction results">Continue to Receipt</button>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="row align-items-center" *ngIf="!stillHasError && hasError">
				<div class="col col-12 text-center receipt-options">
					<div class="h4">Oops... It's not you, it's us.</div>
					<div class="h6">Give us another chance to try that again</div>
					<div class="row" style="margin-top: 20px;">
						<div class="col col-12 text-center">
							<button mat-raised-button color="warn" (click)="dealWithProcessorResponse();" *ngIf="isProcessed" matTooltip="Retry/Resend the transaction"><i class="material-icons" aria-hidden="true">refresh</i> Retry... </button>
						</div>
					</div>
				</div>
			</div>
			<div class="row align-items-center" *ngIf="stillHasError">
				<div class="col col-12 text-center receipt-options">
					<div class="h4">Card Payment Processing</div>
					<div class="h4 warning-label">Sorry, we could not complete your order.</div> 
					<div class="h6 text-center" *ngIf="errorTracerId !== undefined && errorTracerId != null" style="margin-bottom: 18px;">Please reference Tracer ID: {{errorTracerId}}</div>
				</div>
				<div class="col col-12">
					<div class="text-as-paragraph mat-elevation-z1" style="min-height: 486px;">{{responseString}}</div>
				</div>
				<div class="col col-12 text-center">
					<button mat-raised-button color="primary" (click)="reload();" matTooltip="Reload the browser app." style="margin-top: 18px; margin-bottom: 40px;"> &nbsp; &nbsp;<i class="material-icons" aria-hidden="true">cached</i> Try Again &nbsp; &nbsp; </button>
				</div>
			</div>
		</div>
	</div>
</div>